// RecordLayout (was JobLayout, HIERARCHY.md follow-up 3): a record page's body: the work on the left (its Areas), the people and the
// place on the right in a narrower column, divided by a hairline. 320 wide, 296 under 1360, and one
// column under 1100, the side after the work over a rule. Reads only --recordlayout-*.
import type { ReactNode } from 'react';
import './RecordLayout.css';

export interface RecordLayoutProps {
  main: ReactNode;
  side: ReactNode;
  /** The side column's name, for screen readers ("Customer, site and details"). */
  sideLabel: string;
}

export function RecordLayout({ main, side, sideLabel }: RecordLayoutProps) {
  return (
    <div className="fl-recordlayout">
      <div className="fl-recordlayout__main">{main}</div>
      <aside className="fl-recordlayout__side" aria-label={sideLabel}>
        {side}
      </aside>
    </div>
  );
}
